import React from 'react'
import { Animation, Text, Heading, Image, MapWidget, MapMenu, MapItem, MapLayer, MapOverlay, MessageTooltip, Icon } from 'components/library'
import { Layer, Popup } from 'components/library/widgets/map/components'
import img01 from './assets/img01.svg'
import img02 from './assets/img02.svg'
import img03 from './assets/img03.svg'
import img04 from './assets/img04.svg'
import img05 from './assets/img05.svg'
import img06 from './assets/img06.svg'
import popupimg1 from './assets/popupimg1.jpg'
import popupimg2 from './assets/popupimg2.jpg'
import layer01 from './assets/maplayer_2_3_2_1-01.svg'
import layer02 from './assets/maplayer_2_3_2_2-01.svg'
import mapBaseImage from 'components/library/widgets/map/assets/baseMap-01.svg'

import './C02A03Tab02.css'

class C02A03Tab02 extends React.Component {

  state ={
    modal: 0,
  }
  render() {
    return (
      <div className="C02A03Tab02">
        <MapWidget
          mapImage={mapBaseImage}
          mapBounds={[[0, 0], [3556, 3406]]}
          options={{ minZoom: -1.5 }}>

          <MapMenu>
            <MapItem center={[2685,2421]} zoom={-1} label={'Voorwaarden'}>
              <MapOverlay>
                <MessageTooltip>
                  <Text>Als je zonder sleepobject tussen Schiphol-Oost en Schiphol-Centrum rijdt, kan Apron Control je de opdracht geven om via de Noorderlijke trekkerroute te rijden. Apron Control geeft je alleen de opdracht van de Noordelijke trekkerroute gebruik te maken als er op het moment van aanvraag van de sleepbeweging aan de volgende voorwaarden is voldaan:</Text>
                  <ul>
                    <li>Baan 18L-36R en/of baan 04-22 zijn beschikbaar gesteld aan LVNL voor het starten of landen van een vliegtuig.</li>
                    <li>Baan 09-27 is niet beschikbaar gesteld aan LVNL en gaat naar verwachting niet beschikbaar gesteld worden tot jij deze gekruist hebt.</li>
                    <li>Er is geen sprake van BZO.</li>
                  </ul>
                </MessageTooltip>
              </MapOverlay>
              <MapLayer>
                <Layer url={layer01} bounds={[[0, 0], [3556, 3406]]} />
              </MapLayer>
            </MapItem>

            <MapItem center={[2068,2318]} zoom={-1.2} label={'Klaringregels'}>
              <MapLayer>
                <Layer url={layer02} bounds={[[0, 0], [3556, 3406]]} />

                <Popup onClick={() => this.setState({ modal: 1 })} position={[2405,1762]} blue textCenter active={this.state.modal === 1}>
                  <Text>Baan 09-27</Text>
                </Popup>
                <Popup onClick={() => this.setState({ modal: 2 })} position={[1759,2924]} blue textCenter active={this.state.modal === 2}>
                  <Text>Hangar 14</Text>
                </Popup>
              </MapLayer>
              <MapOverlay>

                {this.state.modal === 1 &&
                  <Animation name="slideInDown">
                    <div className="C02A03Tab02-modal">
                      <div className="C02A03Tab02-modal-inner">
                        <div>
                          <Image src={popupimg1}/>
                        </div>
                        <div className="C02A03Tab02-modal-inner-content">
                          <Text><strong>Baan 09-27</strong></Text>
                          <Text>Als je de klaringsaanvraag doet voor het kruisen van baan 09-27, dien je met je trekker op de passeerstrook tegenover N3 te gaan staan.</Text>
                        </div>
                        <div className="C02A03Tab02-modal-close">
                          <a onClick={() => this.setState({ modal: 0 })}>
                            <Icon name="close" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </Animation>
                }
                {this.state.modal === 2 &&
                  <Animation name="slideInDown">
                    <div className="C02A03Tab02-modal">
                      <div className="C02A03Tab02-modal-inner">
                        <div>
                          <Image src={popupimg2}/>
                        </div>
                        <div className="C02A03Tab02-modal-inner-content">
                          <Text><strong>Hangar 14</strong></Text>
                          <Text>Op de dienstweg bij Hangar 14 ter hoogte van Hek 3 dien je:</Text>
                          <ul>
                            <li>rijbaan G vrij te melden (bij bestemming Centrum);</li>
                            <li>klaring voor rijbaan G aan te vragen (bij bestemming Oost.</li>
                          </ul>
                        </div>
                        <div className="C02A03Tab02-modal-close">
                          <a onClick={() => this.setState({ modal: 0 })}>
                            <Icon name="close" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </Animation>
                }

              </MapOverlay>
            </MapItem>

            <MapItem label={'Extra Attentie'}>
              <MapOverlay>
                <div className="has-two-col">
                  <div className="col-01">
                    <Image src={img01} aspectRatio={100}/>
                  </div>
                  <div className="col-02">
                    <Heading h3>Verlichting</Heading>
                    <Text>Om je te kunnen onderscheiden van andere voertuigen dien je een zwaailicht te voeren. </Text>
                  </div>
                </div>
                <div className="has-two-col">
                  <div className="col-01">
                    <Image src={img02} aspectRatio={100} style={{ marginLeft: '-4rem' }}/>
                  </div>
                  <div className="col-02">
                    <Heading h3>Helikopters</Heading>
                    <Text>Op Schiphol-Oost bevindt zich het heliplatform. Je moet daarom rondom rijbaan G en de platformen opletten op hooverende helikopters.</Text>
                  </div>
                </div>
                <div className="has-two-col">
                  <div className="col-01">
                    <Image src={img03} aspectRatio={100}/>
                  </div>
                  <div className="col-02">
                    <Heading h3>Kilo-platform</Heading>
                    <Text>Een deel van de Noordelijke trekkerroute loopt over het Kilo-platform. Aangezien dit platform officieel niet bij Airside hoort, wordt je hier niet actief begeleid door Apron Control. Er geldt daarom een uitluisterplicht. In hoofdstuk 3 leer je welke security regels er op het Kilo-platform gelden.</Text>
                  </div>
                </div>
              </MapOverlay>
            </MapItem>

            <MapItem label={'Voorrangsregels'}>
              <MapOverlay>
                <div className="is-row">
                  <Text><strong>Naast de standaardvoorrangsregels die op Airside gelden, zijn er een aantal aanvullende voorrangregels als je op de Noordelijke trekkerroute rijdt.</strong></Text>
                </div>
                <div className="has-two-col">
                  <div className="col-01">
                    <Image src={img04} aspectRatio={100}/>
                  </div>
                  <div className="col-02">
                    <Text>Je dient op de gehele Noordelijke trekkerroute voorrang te verlenen aan de sneeuwvloot. Hiervoor kunnen de passeerstroken gebruikt worden.</Text>
                  </div>
                </div>
                <div className="has-two-col">
                  <div className="col-01">
                    <Image src={img05} aspectRatio={100}/>
                  </div>
                  <div className="col-02">
                    <Text>Overige voertuigen dienen jou voorrang te verlenen door gebruik te maken van de passeerstroken.</Text>
                  </div>
                </div>
                <div className="has-two-col">
                  <div className="col-01">
                    <Image src={img06} aspectRatio={100}/>
                  </div>
                  <div className="col-02">
                    <Text>Indien jij en een andere vliegtuigtrekker elkaar tegemoet komen, dan dient de vliegtuigtrekker met de passeerstrook aan de rechterzijde gebruik te maken van deze passeerstrook, om de andere vliegtuigtrekker te laten passeren.</Text>
                  </div>
                </div>
              </MapOverlay>
            </MapItem>

          </MapMenu>
        </MapWidget>
      </div>
    )
  }
}

export default C02A03Tab02



// WEBPACK FOOTER //
// ./src/content/chapters/02/03/components/c02_a03_tab_02/C02A03Tab02.js